export const COLORS = [
  
    '#50C878', // Smaragdinė žalia - šviesesnė ir draugiškesnė akiai
    '#F4A261', // Šviesiai oranžinė - šilta, bet ne per ryški
    '#9B6B9E', // Švelniai violetinė - gerai matoma
    '#4A90E2', // Mėlyna - geras kontrastas, tinka daltonizmui

    '#45B7D1', // Turkio - šviesi ir aiški
    '#B784A7', // Šviesiai rožinė - švelni, bet kontrastinga
];
